import {
  ToolbarPopoverButton,
  ToolbarPopoverChoiceRow,
} from "@-/dev.improve.haniverse.components.ui.toolbar.button.popover";
import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";
import { SLIDE_TEXT_SIZES, slideTextSizeLabel } from "@-/dev.improve.haniverse.lib.slide.text-size";

/**
 * The slide text size section of the Learn toolbar's More menu, registered by the slide card so it
 * only appears while a slide is on screen. Each chip writes the `slideTextSize` device setting,
 * which resizes the slide body's text (and nothing outside it) in place.
 */
export function SlideTextSizeButton() {
  const [slideTextSize, setSlideTextSize] = useDeviceSetting("slideTextSize");

  return (
    <ToolbarPopoverButton
      iconSize={16}
      label="Text Size"
      name="MdTextFields"
      testID="slide-text-size-button"
    >
      <ToolbarPopoverChoiceRow
        label="Slide text size"
        onValueChange={setSlideTextSize}
        options={SLIDE_TEXT_SIZES.map((size) => ({
          label: slideTextSizeLabel(size),
          testID: `slide-text-size-${size}`,
          value: size,
        }))}
        value={slideTextSize}
      />
    </ToolbarPopoverButton>
  );
}
